import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { useNavigate } from 'react-router-dom';
import { Phone } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';

const UserCard = ({ item, index = 0 }) => {
  const navigate = useNavigate();
  const isOrangeVariant = index % 2 === 1;

  const handleUserdetail = (item) => {
    localStorage.setItem('user_id', item.user_id);
    navigate(`/users/${item.user_id}`);
  };

  return (
    <Card
      sx={{
        minWidth: 100,
        flexBasis: '30%',
        margin: '10px',
        cursor: 'pointer',
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 4px 16px rgba(12, 61, 110, 0.07)',
        transition: 'box-shadow 0.15s, transform 0.15s',
        '&:hover': {
          boxShadow: '0 8px 24px rgba(12, 61, 110, 0.12)',
          transform: 'translateY(-2px)',
        },
      }}
      onClick={() => handleUserdetail(item)}
    >
      <CardContent sx={{ padding: '22px' }}>
        <Typography
          variant="h5"
          component="div"
          className="APP-COLOR"
          sx={{ mb: 2, display: 'flex', alignItems: 'center', fontSize: 15, fontWeight: 700 }}
        >
          <Avatar
            className={isOrangeVariant ? 'APP-BACKGROUND-2-LIGHT APP-COLOR-2' : 'APP-BACKGROUND-LIGHT APP-COLOR'}
            sx={{ width: 44, height: 44, marginRight: '14px', fontSize: '17px', fontWeight: 700 }}
          >
            {`${item?.user_name.charAt(0).toUpperCase()}`}
          </Avatar>
          {item?.first_name} {item?.last_name}
        </Typography>

        <Typography
          className="APP-TEXT-BODY"
          sx={{ mb: 1, fontSize: 12.5, display: 'flex', alignItems: 'center' }}
        >
          <PersonOutlineOutlinedIcon className="APP-COLOR" sx={{ fontSize: 15, marginRight: '9px' }} />
          {item?.user_name}
        </Typography>

        <Typography
          className="APP-TEXT-BODY"
          sx={{
            mb: 1,
            fontSize: 12.5,
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {item.email ? (
            <>
              <EmailOutlinedIcon className="APP-COLOR" sx={{ fontSize: 15, marginRight: '9px' }} />
              {item.email}
            </>
          ) : (
            <>
              <Phone className="APP-COLOR" sx={{ fontSize: 15, marginRight: '9px' }} />
              {item.phone_number}
            </>
          )}
        </Typography>

        <Typography className="APP-TEXT-BODY" sx={{ mb: 1.5, fontSize: 12.5, display: 'flex', alignItems: 'center' }}>
          <DocumentScannerOutlinedIcon className="APP-COLOR" sx={{ fontSize: 15, marginRight: '9px' }} />
          {item?.successful_scan_count}
        </Typography>

        <Chip
          label="Active"
          size="small"
          className="APP-BACKGROUND-2-LIGHT APP-COLOR-2"
          sx={{
            fontWeight: 700,
            fontSize: 11,
            height: 24,
            '& .MuiChip-label': { padding: '0 12px' },
          }}
        />
      </CardContent>
    </Card>
  );
};

export default UserCard;